import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/document-templates')({
  staticData: { breadcrumb: 'Document Templates', breadcrumbKey: 'K_BREADCRUMB_DOCUMENT_TEMPLATES' },
});
